require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-soligo-apartments.json") })
        }
      }, "path---project-soligo-apartments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-soligo-apartments!./.cache/json/project-soligo-apartments.json
// module id = 583
// module chunks = 231608221292675